export const styles = {
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    px: 3,
    pt: 3,
    pb: 1,
  },
  warningIcon: {
    color: 'warning.D20',
  },
  box: {
    mt: 3,
    px: 1,
    py: 2,
    border: '1px solid',
    borderColor: 'naval.L70',
    borderRadius: 1,
    overflowY: 'auto',
  },
  ul: {
    listStyleType: 'disc',
    pl: 4,
    py: 0,
  },
  li: {
    display: 'list-item',
    px: 0,
    py: 0.25,
  },
  emailSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    mt: 2.5,
  },
  emailAlert: {
    width: '100%',
  },
  emailLinkWrapper: {
    alignSelf: 'flex-start',
  },
  emailLinkDisabled: {
    fontWeight: 600,
    textDecoration: 'underline',
  },
};
